import React from "react";
import { FaLocationDot } from "react-icons/fa6";

import { Typography } from "@/components/Typography";
import type { CouponAddressProps } from "./types";

export const CouponAddress = ({ fullAddress, addressMapsURL }: CouponAddressProps) => {
  return (
    <div className="coupon-template__address">
      <FaLocationDot aria-hidden="true" />
      <a
        href={addressMapsURL}
        target="_blank"
        rel="noreferrer"
        aria-label={fullAddress}
      >
        <Typography
          Tag="p"
          size="xs"
        >
          {fullAddress}
        </Typography>
      </a>
    </div>
  );
};
